<card-component>
    <card-title title="Setup Payment Plan"></card-title>
    <card-content>
        <h6>Please do not refresh this page</h6>
        <div>
            @for (instalment of instalments; track instalment; let i = $index) {
                <div class="row">
                    <div class="list-flex">
                        <div class="flex-item">
                            <pick-a-date
                                [(value)]="instalment.due_date"
                                [error]="formErrors['planinstalments.' + i + '.due_date']"
                            ></pick-a-date>
                        </div>
                        <div class="flex-item">
                            <text-input
                                [(value)]="instalment.amount"
                                [prefix]="systemConfigService.config.currency.symbol"
                                (valueChange)="calculateInstalmentTotal()"
                                [error]="formErrors['planinstalments.' + i + '.amount']"
                            ></text-input>
                        </div>
                        <div class="flex-item" [ngStyle]="{ 'max-width': '100px', 'align-self': 'center' }">
                            <raised-button
                                color="warn"
                                (click)="removeInstalment(i)"
                                [disabled]="instalments.length === 1"
                            ><i class="fa fa-trash"></i></raised-button>
                        </div>
                    </div>
                </div>
            }
        </div>
        <div>
            <raised-button
                (click)="addInstalment()"
                color="accent"
                [styles]="{ width: '100%' }"
                [disabled]="order.total === instalmentTotal + initialPaymentAmount"
            >Add Instalment</raised-button>
        </div>
        <div [ngStyle]="{ 'margin-top': '20px', 'margin-bottom': '20px' }">
            <table class="table table-hover">
                <tbody>
                    <tr>
                        <td>Total Amount</td>
                        <td>
                            <base-currency-component
                              [value]="order.total"
                              [currency]="order.currency"
                              [precision]="order.currency_precision"
                              [locale]="systemConfigService.config.locale"
                            ></base-currency-component>
                        </td>
                    </tr>
                    <tr>
                        <td>Initial Payment Amount</td>
                        <td>
                            <base-currency-component
                                [value]="initialPaymentAmount"
                                [currency]="order.currency"
                                [precision]="order.currency_precision"
                                [locale]="systemConfigService.config.locale"
                            ></base-currency-component>
                        </td>
                    </tr>
                    <tr>
                        <td>Instalment Amount</td>
                        <td>
                            <base-currency-component
                                [value]="instalmentTotal"
                                [currency]="order.currency"
                                [precision]="order.currency_precision"
                                [locale]="systemConfigService.config.locale"
                            ></base-currency-component>
                        </td>
                    </tr>
                    <tr>
                        <td>Remaining</td>
                        <td>
                            <base-currency-component
                                [value]="order.total - instalmentTotal - initialPaymentAmount"
                                [currency]="order.currency"
                                [precision]="order.currency_precision"
                                [locale]="systemConfigService.config.locale"
                            ></base-currency-component>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div>
            <raised-button
                (click)="createSchedule()"
                color="primary"
                [styles]="{ width: '100%' }"
                [disabled]="(order.total !== instalmentTotal + initialPaymentAmount) || isCreatingSchedule"
            >Setup Schedule</raised-button>
        </div>
    </card-content>
</card-component>
